<footer>
  <div class="container">
    <div class="line"><span class="visually-hidden">Footer top line</span></div>
    <div class="py-4 py-md-5">
      <div
        class="d-flex align-items-start justify-content-center justify-content-sm-space-evenly flex-column flex-sm-row flex-wrap"
      >
        <div class="mb-5 mb-sm-4 mb-md-0 mobile-100">
          <p class="h3 mb-3">Quick Quack Car Wash<sup>&copy;</sup></p>
          <ul class="list-inline mb-4 mb-md-5">
            <li class="list-inline-item align-middle">
              <a href="https://www.facebook.com/quickquack">
                <img
                  src="{{ cdnHost }}/icon/Social_Facebook.svg"
                  alt="Facebook Logo"
              /></a>
            </li>
            <li class="list-inline-item align-middle">
              <a href="https://www.instagram.com/quickquack/">
                <img
                  src="{{ cdnHost }}/icon/Social_Instagram.svg"
                  alt="Instagram Logo"
                />
              </a>
            </li>
            <li class="list-inline-item align-middle">
              <a href="https://www.youtube.com/user/QuickQuackCarWash">
                <img
                  src="{{ cdnHost }}/icon/Social_Youtube.svg"
                  alt="YouTube Logo"
              /></a>
            </li>
            <li class="list-inline-item align-middle">
              <a href="https://x.com/quickquack">
                <img src="{{ cdnHost }}/icon/Social_X.svg" alt="X Logo" />
              </a>
            </li>
            <li class="list-inline-item align-middle">
              <a href="https://www.tiktok.com/@quickquackcw">
                <img
                  src="{{ cdnHost }}/icon/Social_Tiktok.svg"
                  alt="TikTok Logo"
                />
              </a>
            </li>
          </ul>
          <p class="mb-0">
            <a
              [routerLink]="['/contact-us']"
              routerLinkActive="router-link-active"
              class="contact-link"
              >Contact Us</a
            >
          </p>
        </div>
        <div class="company mobile-100">
          <p class="h3">Company</p>
          <div class="row">
            <div *ngIf="enableFriendBuy$ | async" class="col-6 py-1">
              <a routerLink="/refer">Refer-A-Friend</a>
            </div>
            <div class="col-6 py-1">
              <a routerLink="{{ aboutQQLink }}">About</a>
            </div>
            <div class="col-6 py-1">
              <a href="{{ charitableGivingLink }}">Charitable Giving</a>
            </div>
            <div class="col-6 py-1">
              <a href="{{ newsroomLink }}">Newsroom</a>
            </div>
            <div class="col-6 py-1">
              <a href="{{ sustainabilityLink }}">Sustainability</a>
            </div>
            <div class="col-6 py-1">
              <a routerLink="{{ privacyPolicyLink }}">Privacy Policy</a>
            </div>
            <div class="col-6 py-1">
              <a routerLink="{{ termsOfUseLink }}">Terms of Use</a>
            </div>
            <div class="col-6 py-1">
              <a routerLink="{{ termsOfServiceLink }}">Terms of Service</a>
            </div>
            <div class="col-6 py-1">
              <a href="{{ commercialLink }}">Commercial Accounts</a>
            </div>
            <div class="col-6 py-1">
              <a href="{{ newLocationsLink }}">New &#038; Coming Locations</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
